
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';
import {ApiMessageService} from '../../core/api-message.service';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';
import {CategoriaTipiEo} from './categoriatipieo.model';

@Injectable()
export class CategoriaTipiEoService extends CommonService<CategoriaTipiEo> {

  public static ROUTE = 'categoriatipieo';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): CategoriaTipiEo {
    return JsonBaseBuilder.jsonToCategoriaTipiEo(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return CategoriaTipiEoService.ROUTE;
  }

  public existingDescr(descr: string, entity: CategoriaTipiEo): Observable<boolean> {
    return this.getBoolean('/existingdescr', new HttpParams()
      .set('descr', descr)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public existingSigla(sigla: string, entity: CategoriaTipiEo): Observable<boolean> {
    return this.getBoolean('/existingsigla', new HttpParams()
      .set('sigla', sigla)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public getTable(items: CategoriaTipiEo[]): Table {
    return Table.buildBaseTable(CategoriaTipiEo.getTableKeys(), items);
  }

}
